import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['selectCorporation']
  static values = { searchUrl: String }

  connect() {
  }

  searchUsageReport() {
    const targetMonth = document.getElementById('target-month').value
    const corporation = document.getElementById('corporation_select').value
    Rails.ajax({
      url: this.searchUrlValue + `&target_month=${targetMonth}&corporation=${corporation}`,
      type: "GET",
      dataType: 'json',
      success: (response)=> {
      }
    });
  }
}
